export default "__VITE_ASSET__BMuuOquv__"